import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import {
  localizationBackend,
  localizationProjectId,
  supportedLngs,
} from "./localization/options";

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: import.meta.env.DEV
        ? `${localizationBackend}?projectId=${localizationProjectId}&lang={{lng}}`
        : "/_locales/{{lng}}.json",
    },
    detection: {
      order: ["navigator", "htmlTag"],
      caches: [],
    },
  });

export default i18n;
